var map = {
	"./arrow-drop.svg": "d348",
	"./arrow-fill.svg": "f69a",
	"./arrow-left.svg": "be80",
	"./arrow-right.svg": "38f1",
	"./calendar-fill.svg": "06be",
	"./calendar.svg": "0f6c",
	"./chronicle.svg": "db93",
	"./decorate-left.svg": "fc88",
	"./down-arrow.svg": "1035",
	"./footer-logo.svg": "3f6c",
	"./logo.svg": "7bed",
	"./mobile-logo.svg": "79ba",
	"./mobile-menu.svg": "0807",
	"./mobile-search.svg": "3cbd",
	"./more.svg": "25de",
	"./news.svg": "6555",
	"./phone.svg": "d214",
	"./play.svg": "5db5",
	"./qr-code.svg": "4733",
	"./quotation.svg": "be8f",
	"./quote-gray.svg": "5799",
	"./search.svg": "6485",
	"./share.svg": "c55e",
	"./sign.svg": "e361",
	"./topping.svg": "66d2",
	"./wb.svg": "c305",
	"./white-search.svg": "45f4",
	"./wx.svg": "a35f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1824";